// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qrLu8UBGDun9QGFRuge0 {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  background: var(--vnsc-bg-secondary, #111820);
  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
  font-family: var(--vnsc-font-family-base);
  font-size: 12px;
  color: var(--vnsc-text-primary, #e0e0e0);
  z-index: 30;
  min-height: 32px;
  /* Never force page width: squeeze internally instead of pushing the dock
     strip off-screen on narrow windows. */
  min-width: 0;
  overflow-x: auto;
  scrollbar-width: none;
}

.qrLu8UBGDun9QGFRuge0::-webkit-scrollbar {
  display: none;
}

.kCNobdB7DnQpE8GsyySe {
  display: flex;
  align-items: center;
  gap: 8px;
}

.IIRWhtpxu0KlcrmYGuFj {
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
}

.TtgOVoPh93t6SK5AwAA1 {
  /* V-05: solid #2563eb + white = 5.2:1 (was accent/white, weak). */
  background: var(--vnsc-accent-strong, #2563eb);
  color: #fff;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
}

.N9xFKq300S_b4JLBY9uK {
  display: flex;
  gap: 2px;
  align-items: center;
}

.zzWmtaOi_GQs2QTGaAEo {
  background: transparent;
  border: none;
  border-radius: 4px;
  color: var(--vnsc-text-secondary, #787b86);
  padding: 4px 8px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
}

.zzWmtaOi_GQs2QTGaAEo:hover {
  background: rgba(255, 255, 255, 0.08);
  color: var(--vnsc-text-primary, #e0e0e0);
}

.ZBIn1GCFJJzPVncF1Cq_ {
  background: var(--vnsc-accent-strong, #2563eb);
  color: #fff;
  font-weight: 600;
}

/* Chart Type Selector */
.Pke_iM9Kk7zHdKxnkSY9 {
  position: relative;
}

.MpHg_NstNZcZZGGLD8YZ {
  display: flex;
  align-items: center;
  gap: 4px;
  background: transparent;
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: 4px;
  color: var(--vnsc-text-secondary, #787b86);
  padding: 4px 8px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
}

.MpHg_NstNZcZZGGLD8YZ:hover,
.MLbR1wcf5yFx8vx3TxFB {
  background: rgba(255, 255, 255, 0.06);
  color: var(--vnsc-text-primary, #e0e0e0);
  border-color: var(--vnsc-accent, #2962ff);
}

.LojOwmTMhoCo5NJoGKDs {
  font-size: 8px;
  margin-left: 2px;
}

.DH8VkyNYtQ8TgY97WqcO {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 4px;
  background: var(--vnsc-bg-primary, #1e293b);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  list-style: none;
  padding: 4px;
  z-index: 100;
  min-width: 120px;
}

/* CLIP-FIX: chart-type menu portals to document.body (fixed) so the header's
   overflow-x:auto can never clip it. Coords come from the toggle button rect. */
.TXD5HgQ3aPr0SmylG_2X {
  position: fixed;
  top: auto;
  left: auto;
  margin-top: 0;
  z-index: 9999;
}

.uRaw1BmtdV_7uHJMrCmD {
  padding: 6px 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  color: var(--vnsc-text-secondary, #787b86);
  transition: background 0.15s ease;
}

.uRaw1BmtdV_7uHJMrCmD:hover {
  background: rgba(255, 255, 255, 0.08);
  color: var(--vnsc-text-primary, #e0e0e0);
}

.dH9qENZhxt9utMz0g4iw {
  background: rgba(41, 98, 255, 0.15);
  color: var(--vnsc-primary, #2962ff);
  font-weight: 600;
}

/* CT-P2: disabled future chart types (Renko/Kagi) + Coming Soon badge. */
.nmLt7EGigLUYivGWB6zo {
  opacity: 0.45;
  cursor: not-allowed;
}

.nmLt7EGigLUYivGWB6zo:hover {
  background: transparent;
  color: var(--vnsc-text-secondary, #787b86);
}

.hwfMGzLZAddfsDwi1CWk {
  margin-left: 8px;
  padding: 1px 6px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.4;
  color: var(--vnsc-primary, #2962ff);
  background: rgba(41, 98, 255, 0.15);
  white-space: nowrap;
}

/* Replay Controls */
.opQ6HJZIrKQNIm2fyABB {
  display: flex;
  align-items: center;
  gap: 2px;
}

.Mlwk4WgtpfocKS9DegX6 {
  display: flex;
  align-items: center;
  gap: 4px;
  background: transparent;
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: 4px;
  color: var(--vnsc-text-secondary, #787b86);
  padding: 4px 8px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
  line-height: 1;
}

.Mlwk4WgtpfocKS9DegX6:hover {
  background: rgba(255, 255, 255, 0.06);
  color: var(--vnsc-text-primary, #e0e0e0);
  border-color: var(--vnsc-accent, #2962ff);
}

.l__QjKfbf75i_b7M_VU_ {
  background: rgba(41, 98, 255, 0.2);
  color: var(--vnsc-primary, #2962ff);
  font-weight: 600;
  border-color: var(--vnsc-primary, #2962ff);
}

.su5MdKWCwgmLMgZCnDaJ {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 6px;
  background: rgba(255, 255, 255, 0.04);
  border-radius: 4px;
}

.ndOjUqlA9BC5HypJlTMM {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--vnsc-text-secondary, #787b86);
  cursor: pointer;
  font-size: 10px;
  transition: all 0.15s ease;
}

.ndOjUqlA9BC5HypJlTMM:hover {
  background: rgba(255, 255, 255, 0.1);
  color: var(--vnsc-text-primary, #e0e0e0);
}

.bjVvJmJ2SMaZqhYSNLl4 {
  color: var(--vnsc-primary, #2962ff);
}

.ZPkTghNcqDoWvgJFT7oz {
  width: 80px;
  height: 4px;
  accent-color: var(--vnsc-accent, #2962ff);
  cursor: pointer;
}

.gwAHoqWTbg6HPaUzhzgF {
  font-size: 10px;
  color: var(--vnsc-text-secondary, #787b86);
  white-space: nowrap;
  min-width: 50px;
}

.gOzfLicXE8xB3pTRlPbR {
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  margin: 0 4px;
}
.gOzfLicXE8xB3pTRlPbR[data-pnl-positive="true"] {
  color: #22bb5c;
}
.gOzfLicXE8xB3pTRlPbR[data-pnl-positive="false"] {
  color: #d7324b;
}

.kzTuspDBU9GZ6SrKWerw {
  display: inline-flex;
  gap: 6px;
  align-items: center;
  font-size: 10px;
  white-space: nowrap;
  margin: 0 4px;
}
.vgcn2guMIvqFbbm8h5Ji {
  padding: 0 4px;
  color: var(--vnsc-text-secondary, #787b86);
  border-right: 1px solid var(--vnsc-border, rgba(148,163,184,0.2));
}
.vgcn2guMIvqFbbm8h5Ji:last-child {
  border-right: none;
}
.vgcn2guMIvqFbbm8h5Ji[data-positive="true"] {
  color: #22bb5c;
}
.vgcn2guMIvqFbbm8h5Ji[data-positive="false"] {
  color: #d7324b;
}

.aoXPxryRflE_ZdWWD4CQ {
  background: transparent;
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: 4px;
  color: var(--vnsc-text-secondary, #787b86);
  font-size: 10px;
  padding: 1px 4px;
  cursor: pointer;
}

/* Menu */
.Hq3vZ_D0Yiv0h9lE8CkI {
  display: flex;
  gap: 2px;
  margin-left: auto;
}

.W1ffYzeffrfPKnIMy7uz {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--vnsc-text-secondary, #787b86);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.W1ffYzeffrfPKnIMy7uz:hover {
  background-color: rgba(255, 255, 255, 0.08);
  color: var(--vnsc-text-primary);
}

.XMeK9vRd3GsJ6_XcMh9l {
  background-color: var(--vnsc-accent, #2962ff);
  color: #fff;
}

.XMeK9vRd3GsJ6_XcMh9l:hover {
  background-color: #1a52d6;
  color: #fff;
}

.pORV6aHCaC6PKeOyJswT {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 26px;
  padding: 0 10px;
  border: 1px solid rgba(41, 98, 255, 0.45);
  border-radius: 4px;
  /* V-09: toned down — flat translucent instead of glowing gradient. */
  background: rgba(41, 98, 255, 0.14);
  color: #dbe4ff;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.15s ease;
  white-space: nowrap;
  box-shadow: none;
}

.pORV6aHCaC6PKeOyJswT:hover {
  background: rgba(41, 98, 255, 0.24);
  box-shadow: none;
}

.hEUbGjZWNDWC6X_OfSyy {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: #ffffff;
  padding: 4px 8px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 11px;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.2);
  display: inline-flex;
  align-items: center;
  user-select: none;
}

.gtp7NqRUksZWQnrKrsiw {
  background: linear-gradient(135deg, var(--vnsc-accent, #22d3ee), #0891b2);
  color: #0a0e17;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 800;
  font-size: 11px;
  letter-spacing: 0.5px;
  display: inline-flex;
  align-items: center;
  user-select: none;
}

.qCW_3O5h4rGPCuuFHz2m {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 6px;
}

.U82BJDBWyWfJjf0H6Iek {
  position: relative;
}

._A7Dq0ebHfrimpiW3ToF {
  position: absolute;
  top: 32px;
  right: 0;
  min-width: 220px;
  max-height: calc(100vh - 100px);
  overflow-y: auto;
  padding: 8px;
  background-color: var(--vnsc-bg-secondary, #0f172a);
  border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.18));
  border-radius: 8px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  gap: 4px;
  z-index: 250;
  scrollbar-width: thin;
}

.jNcjNaU7owfPwa9K0xbU {
  height: 32px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  background: transparent;
  border: none;
  border-radius: 6px;
  color: var(--vnsc-text-secondary, #94a3b8);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  text-align: left;
  transition: all 0.12s ease;
}

.jNcjNaU7owfPwa9K0xbU:hover,
.jNcjNaU7owfPwa9K0xbU.EKfg51PN3drhNvT9hi9b {
  background-color: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.05));
  color: var(--vnsc-text-primary, #e2e8f0);
}

.iOId3eR7LmliAQMe8CK2 {
  display: flex;
  align-items: center;
  gap: 6px;
  background: var(--vnsc-bg-secondary, #111820);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: 6px;
  padding: 6px 10px;
  position: absolute;
  top: 36px;
  left: 6px;
  right: 6px;
  z-index: 220;
  box-shadow: 0 4px 16px rgba(0,0,0,0.4);
  box-sizing: border-box;
}

.MbbFhEPTk8TZXyFJbZsc {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: 8px;
  font-size: 11px;
  font-family: var(--vnsc-font-mono, monospace);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.qN3LAlfAAH20YP4iLkOc {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

/* V-03: one up/down pair (D3). By-field ohlcOpen/High/Low/Close removed. */
.sfbSC7Qw7mD5QebPBoBg {
  color: inherit;
  opacity: 0.75;
  font-weight: 600;
}

.w96A7aLUMcC4btzJKroz {
  color: inherit;
}

.kX2GRkTytwtK_KN_1R4D {
  font-weight: 600;
  margin-left: 4px;
}

.JxXK0GGWPMRm9qSyFGkQ {
  color: var(--vnsc-color-bullish, #26a69a);
}

.INQfocsy0diej7q67uCi {
  color: var(--vnsc-color-bearish, #ef5350);
}

@media (max-width: 640px) {
  .qrLu8UBGDun9QGFRuge0 {
    padding: 3px 6px;
    gap: 4px;
  }

  .IIRWhtpxu0KlcrmYGuFj {
    font-size: 12px;
  }

  .ZPkTghNcqDoWvgJFT7oz {
    width: 60px;
    flex: 1;
  }

  .W1ffYzeffrfPKnIMy7uz {
    width: 24px;
    height: 24px;
  }
}

/* UI-P1: env popover (tier badge + theme toggle) — portal giong dropdownFloating. */
.XwhmLn9Z__yK67FWi7bw {
  position: fixed;
  top: auto;
  left: auto;
  z-index: 9999;
  min-width: 220px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 12px;
  background: var(--vnsc-bg-primary, #1e293b);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  font-size: 12px;
}
.rsWbh5WKQOxTeeyKxh0R {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.LBgnkq3IeIvVuWS3Ymrm {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--vnsc-accent, #22d3ee);
  margin-right: 6px;
}`, "",{"version":3,"sources":["webpack://./src/widget/styles/ohlc-header.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,6CAA6C;EAC7C,oDAAoD;EACpD,yCAAyC;EACzC,eAAe;EACf,wCAAwC;EACxC,WAAW;EACX,gBAAgB;EAChB;0CACwC;EACxC,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kEAAkE;EAClE,8CAA8C;EAC9C,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,8CAA8C;EAC9C,WAAW;EACX,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,6CAA6C;EAC7C,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;EAEE,qCAAqC;EACrC,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,eAAe;EACf,2CAA2C;EAC3C,6CAA6C;EAC7C,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;gFACgF;AAChF;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,6CAA6C;EAC7C,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,cAAc;EACd,0CAA0C;EAC1C,iEAAiE;AACnE;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,6CAA6C;EAC7C,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yDAAyD;AAC3D;;AAEA;EACE,2CAA2C;EAC3C,+BAA+B;AACjC;;AAEA;EACE,6CAA6C;EAC7C,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yCAAyC;EACzC,kBAAkB;EAClB,qEAAqE;EACrE,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,4CAA4C;EAC5C,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yEAAyE;EACzE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,YAAY;EACZ,mDAAmD;EACnD,+DAA+D;EAC/D,kBAAkB;EAClB,+CAA+C;EAC/C,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,iEAAiE;EACjE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,6CAA6C;EAC7C,6CAA6C;EAC7C,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,YAAY;EACZ,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,6CAA6C;EAC7C,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,2EAA2E;AAC3E;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE;IACE,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,OAAO;EACT;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,oFAAoF;AACpF;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,2CAA2C;EAC3C,6CAA6C;EAC7C,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,uCAAuC;EACvC,iBAAiB;AACnB","sourcesContent":[".ohlcHeader {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 4px 8px;\r\n  background: var(--vnsc-bg-secondary, #111820);\r\n  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);\r\n  font-family: var(--vnsc-font-family-base);\r\n  font-size: 12px;\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n  z-index: 30;\r\n  min-height: 32px;\r\n  /* Never force page width: squeeze internally instead of pushing the dock\r\n     strip off-screen on narrow windows. */\r\n  min-width: 0;\r\n  overflow-x: auto;\r\n  scrollbar-width: none;\r\n}\r\n\r\n.ohlcHeader::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.leftGroup {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.symbol {\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  white-space: nowrap;\r\n}\r\n\r\n.timeframe {\r\n  /* V-05: solid #2563eb + white = 5.2:1 (was accent/white, weak). */\r\n  background: var(--vnsc-accent-strong, #2563eb);\r\n  color: #fff;\r\n  padding: 2px 6px;\r\n  border-radius: 4px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n}\r\n\r\n.timeframeGroup {\r\n  display: flex;\r\n  gap: 2px;\r\n  align-items: center;\r\n}\r\n\r\n.timeframeBtn {\r\n  background: transparent;\r\n  border: none;\r\n  border-radius: 4px;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  padding: 4px 8px;\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n.timeframeBtn:hover {\r\n  background: rgba(255, 255, 255, 0.08);\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n}\r\n\r\n.timeframeBtnActive {\r\n  background: var(--vnsc-accent-strong, #2563eb);\r\n  color: #fff;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Chart Type Selector */\r\n.selectorGroup {\r\n  position: relative;\r\n}\r\n\r\n.selectorBtn {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  background: transparent;\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  border-radius: 4px;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  padding: 4px 8px;\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.15s ease;\r\n  white-space: nowrap;\r\n}\r\n\r\n.selectorBtn:hover,\r\n.selectorBtnOpen {\r\n  background: rgba(255, 255, 255, 0.06);\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n  border-color: var(--vnsc-accent, #2962ff);\r\n}\r\n\r\n.selectorArrow {\r\n  font-size: 8px;\r\n  margin-left: 2px;\r\n}\r\n\r\n.dropdown {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  margin-top: 4px;\r\n  background: var(--vnsc-bg-primary, #1e293b);\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  border-radius: 6px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\r\n  list-style: none;\r\n  padding: 4px;\r\n  z-index: 100;\r\n  min-width: 120px;\r\n}\r\n\r\n/* CLIP-FIX: chart-type menu portals to document.body (fixed) so the header's\r\n   overflow-x:auto can never clip it. Coords come from the toggle button rect. */\r\n.dropdownFloating {\r\n  position: fixed;\r\n  top: auto;\r\n  left: auto;\r\n  margin-top: 0;\r\n  z-index: 9999;\r\n}\r\n\r\n.dropdownItem {\r\n  padding: 6px 10px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  transition: background 0.15s ease;\r\n}\r\n\r\n.dropdownItem:hover {\r\n  background: rgba(255, 255, 255, 0.08);\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n}\r\n\r\n.dropdownItemSelected {\r\n  background: rgba(41, 98, 255, 0.15);\r\n  color: var(--vnsc-primary, #2962ff);\r\n  font-weight: 600;\r\n}\r\n\r\n/* CT-P2: disabled future chart types (Renko/Kagi) + Coming Soon badge. */\r\n.dropdownItemDisabled {\r\n  opacity: 0.45;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.dropdownItemDisabled:hover {\r\n  background: transparent;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n}\r\n\r\n.comingSoonBadge {\r\n  margin-left: 8px;\r\n  padding: 1px 6px;\r\n  border-radius: 999px;\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  line-height: 1.4;\r\n  color: var(--vnsc-primary, #2962ff);\r\n  background: rgba(41, 98, 255, 0.15);\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Replay Controls */\r\n.replayControl {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 2px;\r\n}\r\n\r\n.replayToggleBtn {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  background: transparent;\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  border-radius: 4px;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  padding: 4px 8px;\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.15s ease;\r\n  white-space: nowrap;\r\n  line-height: 1;\r\n}\r\n\r\n.replayToggleBtn:hover {\r\n  background: rgba(255, 255, 255, 0.06);\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n  border-color: var(--vnsc-accent, #2962ff);\r\n}\r\n\r\n.replayToggleBtnActive {\r\n  background: rgba(41, 98, 255, 0.2);\r\n  color: var(--vnsc-primary, #2962ff);\r\n  font-weight: 600;\r\n  border-color: var(--vnsc-primary, #2962ff);\r\n}\r\n\r\n.replayBar {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 2px 6px;\r\n  background: rgba(255, 255, 255, 0.04);\r\n  border-radius: 4px;\r\n}\r\n\r\n.replayBtn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 28px;\r\n  height: 28px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  background: transparent;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  cursor: pointer;\r\n  font-size: 10px;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n.replayBtn:hover {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n}\r\n\r\n.replayBtnActive {\r\n  color: var(--vnsc-primary, #2962ff);\r\n}\r\n\r\n.replaySlider {\r\n  width: 80px;\r\n  height: 4px;\r\n  accent-color: var(--vnsc-accent, #2962ff);\r\n  cursor: pointer;\r\n}\r\n\r\n.replayProgress {\r\n  font-size: 10px;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  white-space: nowrap;\r\n  min-width: 50px;\r\n}\r\n\r\n.replayPnl {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  margin: 0 4px;\r\n}\r\n.replayPnl[data-pnl-positive=\"true\"] {\r\n  color: #22bb5c;\r\n}\r\n.replayPnl[data-pnl-positive=\"false\"] {\r\n  color: #d7324b;\r\n}\r\n\r\n.replayAnalytics {\r\n  display: inline-flex;\r\n  gap: 6px;\r\n  align-items: center;\r\n  font-size: 10px;\r\n  white-space: nowrap;\r\n  margin: 0 4px;\r\n}\r\n.replayAnalyticsItem {\r\n  padding: 0 4px;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  border-right: 1px solid var(--vnsc-border, rgba(148,163,184,0.2));\r\n}\r\n.replayAnalyticsItem:last-child {\r\n  border-right: none;\r\n}\r\n.replayAnalyticsItem[data-positive=\"true\"] {\r\n  color: #22bb5c;\r\n}\r\n.replayAnalyticsItem[data-positive=\"false\"] {\r\n  color: #d7324b;\r\n}\r\n\r\n.replaySpeed {\r\n  background: transparent;\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  border-radius: 4px;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  font-size: 10px;\r\n  padding: 1px 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Menu */\r\n.menu {\r\n  display: flex;\r\n  gap: 2px;\r\n  margin-left: auto;\r\n}\r\n\r\n.menuBtn {\r\n  width: 32px;\r\n  height: 32px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  background: transparent;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background-color 0.15s ease, color 0.15s ease;\r\n}\r\n\r\n.menuBtn:hover {\r\n  background-color: rgba(255, 255, 255, 0.08);\r\n  color: var(--vnsc-text-primary);\r\n}\r\n\r\n.menuBtnActive {\r\n  background-color: var(--vnsc-accent, #2962ff);\r\n  color: #fff;\r\n}\r\n\r\n.menuBtnActive:hover {\r\n  background-color: #1a52d6;\r\n  color: #fff;\r\n}\r\n\r\n.upgradeBtn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 4px;\r\n  height: 26px;\r\n  padding: 0 10px;\r\n  border: 1px solid rgba(41, 98, 255, 0.45);\r\n  border-radius: 4px;\r\n  /* V-09: toned down — flat translucent instead of glowing gradient. */\r\n  background: rgba(41, 98, 255, 0.14);\r\n  color: #dbe4ff;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  text-decoration: none;\r\n  transition: all 0.15s ease;\r\n  white-space: nowrap;\r\n  box-shadow: none;\r\n}\r\n\r\n.upgradeBtn:hover {\r\n  background: rgba(41, 98, 255, 0.24);\r\n  box-shadow: none;\r\n}\r\n\r\n.logoBadge {\r\n  background: linear-gradient(135deg, #3b82f6, #1d4ed8);\r\n  color: #ffffff;\r\n  padding: 4px 8px;\r\n  border-radius: 6px;\r\n  font-weight: bold;\r\n  font-size: 11px;\r\n  letter-spacing: 0.5px;\r\n  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.2);\r\n  display: inline-flex;\r\n  align-items: center;\r\n  user-select: none;\r\n}\r\n\r\n.logoBadgeMobile {\r\n  background: linear-gradient(135deg, var(--vnsc-accent, #22d3ee), #0891b2);\r\n  color: #0a0e17;\r\n  padding: 2px 6px;\r\n  border-radius: 4px;\r\n  font-weight: 800;\r\n  font-size: 11px;\r\n  letter-spacing: 0.5px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  user-select: none;\r\n}\r\n\r\n.rightGroupMobile {\r\n  margin-left: auto;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.dropdownContainerMobile {\r\n  position: relative;\r\n}\r\n\r\n.mobileChartSystemMenu {\r\n  position: absolute;\r\n  top: 32px;\r\n  right: 0;\r\n  min-width: 220px;\r\n  max-height: calc(100vh - 100px);\r\n  overflow-y: auto;\r\n  padding: 8px;\r\n  background-color: var(--vnsc-bg-secondary, #0f172a);\r\n  border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.18));\r\n  border-radius: 8px;\r\n  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  z-index: 250;\r\n  scrollbar-width: thin;\r\n}\r\n\r\n.menuActionBtn {\r\n  height: 32px;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0 10px;\r\n  background: transparent;\r\n  border: none;\r\n  border-radius: 6px;\r\n  color: var(--vnsc-text-secondary, #94a3b8);\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  width: 100%;\r\n  text-align: left;\r\n  transition: all 0.12s ease;\r\n}\r\n\r\n.menuActionBtn:hover,\r\n.menuActionBtn.active {\r\n  background-color: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.05));\r\n  color: var(--vnsc-text-primary, #e2e8f0);\r\n}\r\n\r\n.replayBarMobile {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  background: var(--vnsc-bg-secondary, #111820);\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  border-radius: 6px;\r\n  padding: 6px 10px;\r\n  position: absolute;\r\n  top: 36px;\r\n  left: 6px;\r\n  right: 6px;\r\n  z-index: 220;\r\n  box-shadow: 0 4px 16px rgba(0,0,0,0.4);\r\n  box-sizing: border-box;\r\n}\r\n\r\n.ohlcCluster {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-left: 8px;\r\n  font-size: 11px;\r\n  font-family: var(--vnsc-font-mono, monospace);\r\n  font-variant-numeric: tabular-nums;\r\n  white-space: nowrap;\r\n}\r\n\r\n.ohlcItem {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 2px;\r\n}\r\n\r\n/* V-03: one up/down pair (D3). By-field ohlcOpen/High/Low/Close removed. */\r\n.ohlcLabel {\r\n  color: inherit;\r\n  opacity: 0.75;\r\n  font-weight: 600;\r\n}\r\n\r\n.ohlcValue {\r\n  color: inherit;\r\n}\r\n\r\n.ohlcChange {\r\n  font-weight: 600;\r\n  margin-left: 4px;\r\n}\r\n\r\n.ohlcUp {\r\n  color: var(--vnsc-color-bullish, #26a69a);\r\n}\r\n\r\n.ohlcDown {\r\n  color: var(--vnsc-color-bearish, #ef5350);\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .ohlcHeader {\r\n    padding: 3px 6px;\r\n    gap: 4px;\r\n  }\r\n\r\n  .symbol {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .replaySlider {\r\n    width: 60px;\r\n    flex: 1;\r\n  }\r\n\r\n  .menuBtn {\r\n    width: 24px;\r\n    height: 24px;\r\n  }\r\n}\r\n\r\n/* UI-P1: env popover (tier badge + theme toggle) — portal giong dropdownFloating. */\r\n.envPopover {\r\n  position: fixed;\r\n  top: auto;\r\n  left: auto;\r\n  z-index: 9999;\r\n  min-width: 220px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  padding: 10px 12px;\r\n  background: var(--vnsc-bg-primary, #1e293b);\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  border-radius: 6px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\r\n  font-size: 12px;\r\n}\r\n.envRow {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n}\r\n.liveBadgeDot {\r\n  display: inline-block;\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 50%;\r\n  background: var(--vnsc-accent, #22d3ee);\r\n  margin-right: 6px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ohlcHeader": `qrLu8UBGDun9QGFRuge0`,
	"leftGroup": `kCNobdB7DnQpE8GsyySe`,
	"symbol": `IIRWhtpxu0KlcrmYGuFj`,
	"timeframe": `TtgOVoPh93t6SK5AwAA1`,
	"timeframeGroup": `N9xFKq300S_b4JLBY9uK`,
	"timeframeBtn": `zzWmtaOi_GQs2QTGaAEo`,
	"timeframeBtnActive": `ZBIn1GCFJJzPVncF1Cq_`,
	"selectorGroup": `Pke_iM9Kk7zHdKxnkSY9`,
	"selectorBtn": `MpHg_NstNZcZZGGLD8YZ`,
	"selectorBtnOpen": `MLbR1wcf5yFx8vx3TxFB`,
	"selectorArrow": `LojOwmTMhoCo5NJoGKDs`,
	"dropdown": `DH8VkyNYtQ8TgY97WqcO`,
	"dropdownFloating": `TXD5HgQ3aPr0SmylG_2X`,
	"dropdownItem": `uRaw1BmtdV_7uHJMrCmD`,
	"dropdownItemSelected": `dH9qENZhxt9utMz0g4iw`,
	"dropdownItemDisabled": `nmLt7EGigLUYivGWB6zo`,
	"comingSoonBadge": `hwfMGzLZAddfsDwi1CWk`,
	"replayControl": `opQ6HJZIrKQNIm2fyABB`,
	"replayToggleBtn": `Mlwk4WgtpfocKS9DegX6`,
	"replayToggleBtnActive": `l__QjKfbf75i_b7M_VU_`,
	"replayBar": `su5MdKWCwgmLMgZCnDaJ`,
	"replayBtn": `ndOjUqlA9BC5HypJlTMM`,
	"replayBtnActive": `bjVvJmJ2SMaZqhYSNLl4`,
	"replaySlider": `ZPkTghNcqDoWvgJFT7oz`,
	"replayProgress": `gwAHoqWTbg6HPaUzhzgF`,
	"replayPnl": `gOzfLicXE8xB3pTRlPbR`,
	"replayAnalytics": `kzTuspDBU9GZ6SrKWerw`,
	"replayAnalyticsItem": `vgcn2guMIvqFbbm8h5Ji`,
	"replaySpeed": `aoXPxryRflE_ZdWWD4CQ`,
	"menu": `Hq3vZ_D0Yiv0h9lE8CkI`,
	"menuBtn": `W1ffYzeffrfPKnIMy7uz`,
	"menuBtnActive": `XMeK9vRd3GsJ6_XcMh9l`,
	"upgradeBtn": `pORV6aHCaC6PKeOyJswT`,
	"logoBadge": `hEUbGjZWNDWC6X_OfSyy`,
	"logoBadgeMobile": `gtp7NqRUksZWQnrKrsiw`,
	"rightGroupMobile": `qCW_3O5h4rGPCuuFHz2m`,
	"dropdownContainerMobile": `U82BJDBWyWfJjf0H6Iek`,
	"mobileChartSystemMenu": `_A7Dq0ebHfrimpiW3ToF`,
	"menuActionBtn": `jNcjNaU7owfPwa9K0xbU`,
	"active": `EKfg51PN3drhNvT9hi9b`,
	"replayBarMobile": `iOId3eR7LmliAQMe8CK2`,
	"ohlcCluster": `MbbFhEPTk8TZXyFJbZsc`,
	"ohlcItem": `qN3LAlfAAH20YP4iLkOc`,
	"ohlcLabel": `sfbSC7Qw7mD5QebPBoBg`,
	"ohlcValue": `w96A7aLUMcC4btzJKroz`,
	"ohlcChange": `kX2GRkTytwtK_KN_1R4D`,
	"ohlcUp": `JxXK0GGWPMRm9qSyFGkQ`,
	"ohlcDown": `INQfocsy0diej7q67uCi`,
	"envPopover": `XwhmLn9Z__yK67FWi7bw`,
	"envRow": `rsWbh5WKQOxTeeyKxh0R`,
	"liveBadgeDot": `LBgnkq3IeIvVuWS3Ymrm`
};
export default ___CSS_LOADER_EXPORT___;
